// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { getProperties, $delete, createOrUpdate, get, list } from "./operations.js";
export {
  LicensesGetPropertiesOptionalParams,
  LicensesDeleteOptionalParams,
  LicensesCreateOrUpdateOptionalParams,
  LicensesGetOptionalParams,
  LicensesListOptionalParams,
} from "./options.js";
